import router from '@/router'

// initial state
const state = {
  open: false,
  item: null
}

// getters
const getters = {
  currentItem: state => state.item
}

// actions
const actions = {

  toggle ({ commit }, val) {
    commit('setDrawer', val)
  },

  open ({ commit }) {
    commit('setDrawer', true)
  },

  close ({ commit }) {
    commit('setDrawer', false)
  },

  item ({ dispatch, commit }, payload) {
    if (payload) {
      commit('setItem', (payload.item || payload))
      let route = (payload.item || payload).route
      if (route) router.push(route)
    } else commit('setItem', null)
    if (payload && payload.closeDrawer) dispatch('close')
  }
}

// mutations
const mutations = {
  setDrawer (state, val) {
    if (val === undefined) val = !state.open
    state.open = val
  },

  setItem (state, item) {
    state.item = item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/drawer.js